import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { AppNavigationCreator } from '@layout/core/classes';
import { AppNavigation } from '@layout/core/interfaces';

import { CurrentUserService } from '@core/services';
import { CurrentUser } from '@shared/interfaces';
import { UserRoleEnum } from '@shared/enums/user-role.enum';

@Component({
    selector: 'app-navigation[isSidebarCollapsed]',
    templateUrl: './app-navigation.component.html',
    styleUrls: ['./app-navigation.component.scss'],
})
export class AppNavigationComponent implements OnInit, OnChanges {
    @Input() isSidebarCollapsed = true;
    @Input() isOnMobile = true;
    @Output() toggleIsCollapsed: EventEmitter<void> = new EventEmitter<void>();

    appNavigation: AppNavigation[][] = [];
    overlayStyle = { 'margin-left': '90px', 'margin-top': '-120px' };
    currentUser : CurrentUser | null = null;
    constructor(private userService : CurrentUserService) {}

    async loadUser() : Promise<void>{
        this.userService.currentUser$.subscribe(user => {
            this.currentUser = user;
            this.initAppNavigation();
        });
    }

    async ngOnInit(): Promise<void> {
        await this.loadUser();
        this.initAppNavigation();
    }

    ngOnChanges(): void {
        if (this.isSidebarCollapsed) {
            this.appNavigation.forEach(navList => {
                navList.forEach(navItem => {
                    navItem.expanded = false;
                });
            });
        }
    }

    navItemClick(navItem: AppNavigation): void {
        if (!navItem.submenu) {
            return;
        }

        navItem.expanded = !navItem.expanded;

        if (navItem.expanded) {
            this.appNavigation.forEach(navList => {
                navList.forEach(item => {
                    if (item.expanded && item.id !== navItem.id) {
                        item.expanded = false;
                    }
                });
            });
        }

        if (this.isSidebarCollapsed) {
            this.toggleIsCollapsed.emit();
        }
    }

    initAppNavigation(): void {
        this.appNavigation.splice(0, this.appNavigation.length);
        if(this.currentUser != null && this.currentUser.roles.includes(UserRoleEnum.ADMIN)){
            this.appNavigation.push([
                AppNavigationCreator.create({
                    id: 'dashboard',
                    label: 'appNav.dashboard',
                    url: 'manage-pickups',
                    icon: 'fa-light fa-objects-column',
                })]);
        }
        this.appNavigation.push([
            AppNavigationCreator.create({
                id:'new',
                label: 'appNav.schedulePickup',
                url: 'schedule-pickup',
                icon: 'fa-light fa-circle-plus'
            }),
        ]);
    }
}
